export { ResearchEditPage } from './ResearchEditPage';
export { ResearchPage } from './ResearchPage';
export { ResearchCreatePage } from './ResearchCreatePage';
export { ResearchComparisonPage } from './ResearchComparison';
